<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/dKPkAl/tc-custom/9781526772954.jpg?1716521199597" alt="This image is the cover for the book Beating the Nazi Invader"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Beating the Nazi Invader
      </h1>
      <p class="bookDescription body article font2">
        <b>“A compelling examination of an aspect of World War II that always has a rapt audience: espionage . . . With a cast of colorful characters.” —<i>Library Journal</i> (starred review)</b><br/><br/><i>Beating the Nazi Invader</i> is a revealing and disturbing exploration of the darker history of Nazis, spies and “Fifth Columnist” saboteurs in Britain, and the extensive top-secret countermeasures taken before and during the real threat of invasion in 1940.<br/><br/>The author’s research describes the Nazi Party organization in Britain and reveals the existence of the Gestapo headquarters in central London. The reader gains vivid insights into Nazi agents and terrorist cells, the Special Branch and MI5 teams who hunted them and investigated murders believed to have been committed by Third Reich agents on British soil.<br/><br/>Accessing a host of recently declassified files the book explores the highly classified measures taken for the protection of the Royal Family, national treasures and gold reserves. The British government made extensive plans for the continuation of government in the event of invasion including the creation of all-powerful Regional Commissioners, “Black Lists” of suspected collaborators and a British resistance organization. We also learn of the Nazis’ own occupation measures for suborning the population and the infamous Sonderfahndungsliste G.B, the Nazi “Special Wanted List.”<br/><br/>The result is a fascinating insight into the measures and actions taken to ensure that Great Britain did not succumb to the gravest threat of enemy invasion and occupation for centuries.<br/><br/><b>“Provides fresh and incisive answers to some intriguing 80-year-old mysteries about wartime espionage.” —Britain at War</b><br/><br/><b>“A truly engrossing work.” —History of War Magazine</b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Neil R. Storey
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Pen and Sword Military
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?39701e01